export default function isForbidden(error) {
  if (error == null || error.graphQLErrors == null) {
    return false;
  }
  return error.graphQLErrors.some(
    (gqlError) => gqlError.extensions && gqlError.extensions.code === 'FORBIDDEN'
  );
}
